<template>
  <div>
    <a ref="autoLink" :href="url" rel="noopener noreferrer" style="display: none;"></a>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login, loginMobile, registerVerify, register, getCodeApi, bocomUrl } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      url: "", //交行授权页面
      navList: ["账号登录", "快速登录"],
      current: 1,
      account: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false,
      redirect_uri: "",
    };
  },
  mounted: function() {
    // this.getCode();
    // this.getLogoImage();
    // const baurl = localStorage.getItem('BACK_URL') ? localStorage.getItem('BACK_URL') : "";
    // if(baurl!=""){
    //   window.location.href = baurl;
    //   return;
    // }
    this.getUrl();
  },
  methods: {
    // again() {
    //   this.codeUrl = VUE_APP_API_URL + "/sms_captcha?" + "key=" + this.keyCode + Date.parse(new Date());
    // },
    getUrl() {

      bocomUrl()
        .then((res) => {
          
          let url = res.data.url;
          this.url =url;
          console.log(res);
          // return;
          this.$nextTick(() => {
            this.$refs.autoLink.click();
          });
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    getCode() {
      getCodeApi()
        .then((res) => {
          this.keyCode = res.data.key;
        })
        .catch((res) => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then((res) => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码")), chs_phone(chs_phone.message())],
            captcha: [required(required.message("验证码")), alpha_num(alpha_num.message("验证码"))],
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread"),
      })
        .then((res) => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time,
          };
          that.$store.commit("LOGIN", datas);
          // let newTime = Math.round(new Date() / 1000);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码")), chs_phone(chs_phone.message())],
            captcha: [required(required.message("验证码")), alpha_num(alpha_num.message("验证码"))],
            password: [required(required.message("密码")), attrs.range([6, 16], attrs.range.message("密码")), alpha_num(alpha_num.message("密码"))],
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: cookie.get("spread"),
      })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch((res) => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码")), chs_phone(chs_phone.message())],
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (that.formItem == 2) that.type = "register";
      await registerVerify({
        phone: that.account,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal,
      })
        .then((res) => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch((res) => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { account, password, codeVal } = this;
      try {
        await this.$validator({
          account: [required(required.message("账号")), attrs.range([5, 16], attrs.range.message("账号")), alpha_num(alpha_num.message("账号"))],
          password: [required(required.message("密码")), attrs.range([6, 16], attrs.range.message("密码")), alpha_num(alpha_num.message("密码"))],
          codeVal: this.isShowCode ? [required(required.message("验证码")), attrs.length(4, attrs.length.message("验证码")), alpha_num(alpha_num.message("验证码"))] : [],
        }).validate({ account, password, codeVal });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ account, password, code: codeVal })
        .then(({ data }) => {
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time,
          };
          this.$store.commit("LOGIN", datas);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
        })
        .catch((e) => {
          this.$dialog.error(e.msg);
        });
    },
  },
};
</script>
<style scoped>
.code img {
  width: 100%;
  height: 100%;
}
</style>